import { render, staticRenderFns } from "./TipoViaticoPage.vue?vue&type=template&id=071c4b55"
import script from "./TipoViaticoPage.js?vue&type=script&lang=js&external"
export * from "./TipoViaticoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports